interface TopBarProps {
  title: string;
}

export default function TopBar({ title }: TopBarProps) {
  return (
    <div
      style={{
        backgroundColor: "#40B9D8",
        color: "white",
        padding: "0 16px",
        fontSize: "18px",
        fontWeight: 500,
        textAlign: "center",
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {title}
    </div>
  );
}
